// @flow
import styled from '@emotion/styled';
import { typography, SPACING } from '@tablekit/theme';
import RichText from 'components/RichText';
import Title from 'styled/Title';
import BodyPadding from 'styled/BodyPadding';
import { CallToActionBackground } from 'components/CallToAction';
import type { BlokComponentPropsType, DocType } from '../types';
import { Column } from './Page';

type BlokPropsType = {
  content: DocType,
  title: string
};

const Wrapper = styled.div`
  margin-top: ${SPACING.L8};
  @media (min-width: 576px) {
    margin-top: 0;
  }
`;

const Body = styled(RichText)`
  &,
  & * {
    white-space: pre-wrap;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    ${typography('L5')};
    margin-bottom: ${SPACING.L5};
  }

  p {
    margin-bottom: ${SPACING.L2};
  }

  th {
    font-weight: bold;
    text-align: left;
  }
`;

const StaticContent = ({
  blok: { content, title },
  id
}: BlokComponentPropsType<BlokPropsType>) => (
  <Wrapper id={id}>
    <Column>
      <BodyPadding>
        <Title align="left">{title}</Title>
        <Body richText={content} />
        <CallToActionBackground isWhite />
      </BodyPadding>
    </Column>
  </Wrapper>
);

export default StaticContent;
